import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

export const ModalConfig: NgbModalOptions = {
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
}